import { Input } from '@library/components/inputs';
import { RulesetsContext } from '@bo-hooks/rulesets/useRulesetsContext';
import { useContext } from 'react';

export const Metadata = () => {
  const { currentRuleset } = useContext(RulesetsContext);

  const disabledClassname =
    'bg-soFresh-130 text-soClean-150 border-soFresh-140 placeholder:text-soClean-170 block w-full rounded-md border py-1.5 sm:text-sm sm:leading-6';

  return (
    <div className="bg-soFresh-110 text-soClean-160 font-heebo flex h-fit w-full flex-col gap-4 rounded-md p-5">
      <span className="text-soClean-100 font-heebo text-lg">Metadata</span>

      {currentRuleset ? (
        <div className="flex flex-col gap-4 text-sm">
          <div>
            <span>Ruleset ID</span>
            <Input
              disabled
              value={currentRuleset?.id || ''}
              onValueChange={() => {}}
              className={disabledClassname}
            />
          </div>
          <div>
            <span>Ruleset Name</span>
            <Input
              disabled
              value={currentRuleset?.attributes.name || ''}
              onValueChange={() => {}}
              className={disabledClassname}
            />
          </div>
          <div>
            <span>Ruleset Description</span>
            <Input
              disabled
              value={currentRuleset?.attributes.description || ''}
              onValueChange={() => {}}
              className={disabledClassname}
            />
          </div>
        </div>
      ) : (
        <>Unable to load ruleset</>
      )}
    </div>
  );
};
